
<template>
    <div v-html="innerText"></div>
</template>
<script>
import axios from 'axios'
import { useRoute } from 'vue-router';
export default {
    data(){
        return{
            innerText: ''
        }
    },
    methods:{
        //立即充值
        async pay() {
            const route =useRoute()
            axios.post('https://ceshi.uxiutv.com/api/recharge/noNeedLoginSendPay',{
            // axios.post('https://admin.uxiutv.com/api/recharge/noNeedLoginSendPay',{
                    order_id: route.query.order_id,
                    pay_way: 'alipay_wap',
            }).then(res=>{
                this.innerText = res.data.replace(/<script[\s\S]*?<\/script>/g, '')
                console.log(this.innerText);
                this.$nextTick(() => {
                    document.forms[0].submit()   //渲染支付宝支付页面
                })
            });
        }
    },
    mounted(){
        this.pay()
    }
}
</script>
<style scoped>
</style>